import { render, staticRenderFns } from "./AlertTemp.vue?vue&type=template&id=565f0f76&scoped=true"
import script from "./AlertTemp.vue?vue&type=script&lang=js"
export * from "./AlertTemp.vue?vue&type=script&lang=js"
import style0 from "./AlertTemp.vue?vue&type=style&index=0&id=565f0f76&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "565f0f76",
  null
  
)

export default component.exports